import './payments.module';
import './$payment.factory';

import './components';
import './services';
